module.exports = __webpack_public_path__ + "3d75cecaed484c172f1645784047fa0f.svg";